/**
 * Service: datePickerNote
 */
angular.module('acme.common.service.datePickerNote', [])
.service('DatePickerNoteService', [function() {

    return {

      notes: {},

      init: function() {
        return true;
      },

      register: function(id, module) {
        this.create(id);
        if (module) {
          this.notes[id] = {
            module: module || {},
            note: ''
          };
        }
      },

      create: function(id) {

        if (!this.notes[id]) {
          this.notes[id] = {
            module: {},
            note: ''
          };
        }

      },

      update: function(id, note, module) {
        this.create(id);

        if (note) {
          this.notes[id].note = note;
        }

        if (module) {
          this.notes[id].module = module;
        }

        if (this.notes[id].module) {
          this.notes[id].module.note = note;
        }

      }

    };

}]);